import styled from "@emotion/styled";

export const IconTextList = styled("div")`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 20px;
`;
